export default "__VITE_ASSET__DHzdqVXC__"